// Pull-to-refresh touch gesture: swipe down 80px from the top of the page
// triggers `onRefresh`. Generic — no app state beyond the in-flight flag.
import { useState, useEffect } from "react";

export function usePullToRefresh(onRefresh, enabled) {
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    let startY = 0;
    let pulling = false;
    const trigger = async () => {
      if (!enabled || refreshing) return;
      setRefreshing(true);
      try { await onRefresh(); }
      catch (e) { console.error("Refresh error", e); }
      finally { setRefreshing(false); }
    };
    const onTouchStart = (e) => {
      if (window.scrollY === 0) startY = e.touches[0].clientY;
    };
    const onTouchMove = (e) => {
      if (!startY) return;
      const dy = e.touches[0].clientY - startY;
      if (dy > 80 && !pulling && window.scrollY === 0) {
        pulling = true;
        trigger();
      }
    };
    const onTouchEnd = () => { startY = 0; pulling = false; };
    document.addEventListener("touchstart", onTouchStart, { passive: true });
    document.addEventListener("touchmove", onTouchMove, { passive: true });
    document.addEventListener("touchend", onTouchEnd, { passive: true });
    return () => {
      document.removeEventListener("touchstart", onTouchStart);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", onTouchEnd);
    };
  }, [enabled, refreshing]); // eslint-disable-line react-hooks/exhaustive-deps

  return { refreshing };
}
